import React from 'react';
import { Query } from 'react-apollo';

import GolfPlayers from '~/components/GraphQLEventDescriptionCard/LeagueCards/GolfPlayers';

import GolfEventRounds from '~/graphql/queries/GolfEventRounds.graphql';
import GolfEventPlayerRecords from '~/graphql/queries/GolfEventPlayerRecords.graphql';

const GolfPlayerContainer = ({ event, eventStatus }) => {
  let query;
  let variables;

  if (event.eventType === 'STROKE_PLAY' || event.status === 'SCHEDULED') {
    query = GolfEventPlayerRecords;
    variables = { id: event.id };
  } else {
    query = GolfEventRounds;
    variables = { id: event.bareId, needsScorecard: true };
  }
  return (
    <Query query={query} variables={variables}>
      {({ loading, error, data }) => {
        if (loading) return null;
        if (error) return <div>No Player info available</div>;

        return <GolfPlayers data={data} event={event} eventStatus={eventStatus} />;
      }}
    </Query>
  );
};

export default GolfPlayerContainer;
